import React, { useEffect, useState } from "react";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import HOST_URL from "../../../utils/Url";
import Card from "@mui/material/Card";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import { useNavigate, useLocation } from "react-router-dom";
import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { toast } from "react-toastify";
import ToastApp from "../../../ToastApp";
import DeleteIcon from "@mui/icons-material/Delete";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CircularProgress from "@mui/material/CircularProgress";
import moment from "moment";
import { secureGetItem } from "../../../utils/encryption";

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
  isView: boolean;
  isExport?: boolean; // Optional, add if export permission is needed
}

export default function DocFiles() {
  const [Docs, setDocs] = useState([]);
  const [columns, setColumns] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
   const [permissionLoaded, setPermissionLoaded] = useState(false);
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
    isView:false,
    isExport:false
  });

  let navigate = useNavigate();
  const { t } = useTranslation();

 useEffect(() => {
   const data = secureGetItem("userdata");   // ✅ decrypt + parse
 
   if (data && data.length > 0) {
     const userPermissionData = data[0]?.userPermission;
     const menudata = userPermissionData?.[0]?.parentMenu || [];
 
     for (let i = 0; i < menudata.length; i++) {
       const childMenudata = menudata[i]?.childMenu || [];
       const pathrow = childMenudata.find(
         (x: any) => x.path === location.pathname
       );
 
       if (pathrow) {
         setPermissionData({
           isAdd: pathrow.isAdd,
           isEdit: pathrow.isEdit,
           isPrint: pathrow.isPrint,
           isDel: pathrow.isDel,
            isView: pathrow.isView,
            isExport: pathrow.isExport 
         });
         break;
       }
     }
   }
 setPermissionLoaded (true);
   // fetchZonesData();
 }, [location.pathname]);
  // }, [isLoading]);
  const routeChangeAdd = () => {
    let path = `/DocManagement/DocFilesAdd`;
    navigate(path);
  };

  const routeChangeEdit = (row: any) => {
    let path = `/DocManagement/DocFilesEdit`;
    navigate(path, {
      state: row,
    });
  };

  let delete_id = "";

  const accept = () => {
    const collectData = {
      pdFid: delete_id,
    };
    console.log("collectData " + JSON.stringify(collectData));
    axios
      .post(HOST_URL.HOST_URL2 + `DocFiles/DeleteDocFiles`,  collectData,
      )
      .then((response) => {
        if (response.data.isSuccess) {
          toast.success(response.data.mesg);
        } else {
          toast.error(response.data.mesg);
        }
        fetchDocData();
      });
  };

  const reject = () => {
    // toast.warn({summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    toast.warn("Rejected: You have rejected", { autoClose: 3000 });
  };
      useEffect(() => {
        if(permissionLoaded){
      fetchDocData();
        }
    }, [permissionLoaded]);
  const handledeleteClick = (del_id: any) => {
    // console.log(del_id + " del_id ");
    delete_id = del_id;
    confirmDialog({
      message: "Do you want to delete this record ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      acceptClassName: "p=-button-danger",
      accept,
      reject,
    });
  };

  const fetchDocData = async () => {
    try {
      const collectData = {
        pdFid: -1,
        user_id: 0,
      };
      console.log("collectData", collectData);
      const response = await axios.post(
        HOST_URL.HOST_URL2 + `DocFiles/GetDocFiles`,
        collectData
      );
      console.log("result", response.data.data);
      const data = response.data.data;
      const DocsWithIds = data.map((doc: any, index: any) => ({
        ...doc,
        serialNo: index + 1,
        id: doc.pdFid,
      }));

      setDocs(DocsWithIds);
      setIsLoading(false);

      if (data.length > 0) {
            const actionColumn: GridColDef[] =
          permissionData?.isEdit || permissionData?.isDel || permissionData?.isView
            ? [
                {
                  field: "actions",
                  headerClassName: "MuiDataGrid-colCell",
                  headerName: t("text.Action"),
                  width: 180,
                  renderCell: (params) => (
                    <Stack
                      spacing={1}
                      direction="row"
                      sx={{ alignItems: "center", marginTop: "5px" }}
                    >
                      {permissionData?.isEdit && (
                        <EditIcon
                          style={{ fontSize: "20px", color: "blue", cursor: "pointer" }}
                          onClick={() => routeChangeEdit(params.row)}
                        />
                      )}
        
                      {permissionData?.isDel && (
                        <DeleteIcon
                          style={{ fontSize: "20px", color: "red", cursor: "pointer" }}
                          onClick={() => handledeleteClick(params.row.id)}
                        />
                      )}
        
                     
                    </Stack>
                  ),
                },
              ]
            : [];
        const columns: GridColDef[] = [
          ...actionColumn,
       

     

          {
            field: "serialNo",
            headerName: t("text.SrNo"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },

          {
            field: "pdfName",
            headerName: t("text.PdfName"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "keywords",
            headerName: t("text.Keywords"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
          },
          {
            field: "entryDate",
            headerName: t("text.EntryDate"),
            flex: 1,
            headerClassName: "MuiDataGrid-colCell",
            renderCell: (params: any) => {
              return moment(params.row.entryDate).format("DD-MM-YYYY");
            },
          },
        ];
        setColumns(columns as any);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      // setLoading(false);
    }
  };

  const adjustedColumns = columns.map((column: any) => ({
    ...column,
  }));

  return (
    <>
      <Card
        style={{
          width: "100%",
          // height: "100%",
          backgroundColor: "#E9FDEE",
          // border: ".5px solid #FF7722 ",
          marginTop: "3vh",
        }}
      >
        <Paper
          sx={{
            width: "100%",
            overflow: "hidden",
            "& .MuiDataGrid-colCell": {
              backgroundColor: `var(--grid-headerBackground)`,
              color: `var(--grid-headerColor)`,
              fontSize: 17,
              fontWeight: 900,
            },
          }}
          style={{ padding: "10px" }}
        >
          <ConfirmDialog />

          <Typography
            gutterBottom
            variant="h5"
            component="div"
            sx={{ padding: "20px" }}
            align="left"
          >
            {t("text.DocFiles")}
          </Typography>
          <Divider />

          <Box height={10} />

          <Stack direction="row" spacing={2} classes="my-2 mb-2">
           { permissionData?.isAdd == true && (
            <Button
              onClick={routeChangeAdd}
              variant="contained"
              endIcon={<AddCircleIcon />}
              size="large"
              style={{backgroundColor:`var(--header-background)`}}
            >
              {t("text.add")}
            </Button>
           )}

            {/*{permissionData?.isPrint == true ? (
              <Button variant="contained" endIcon={<PrintIcon />} size="large">
                {t("text.print")}
              </Button>
            ) : (
              ""
            )} */}
          </Stack>

          {isLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <Box>
              <br />
              <div style={{ width: "100%", backgroundColor: `var(--grid-background)` }}>
                <DataGrid
                  rows={Docs}
                  columns={adjustedColumns}
                  autoHeight
                  slots={{
                    toolbar: GridToolbar,
                  }}
                  rowSpacingType="border"
                  pagination={true}
                  pageSizeOptions={[5, 10, 25, 50, 100].map((size) => ({
                    value: size,
                    label: `${size}`,
                  }))}
                  initialState={{
                    pagination: { paginationModel: { pageSize: 5 } },
                  }}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,
                    },
                  }}
                />
              </div>
            </Box>
          )}
        </Paper>
      </Card>
      <ToastApp />
    </>
  );
}
